import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/recycler-centers/:recyclerCenterId',
    name: 'recyclerCenterDetail',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/RecyclerCenterDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recyclers/:recyclerId/centers/create',
    name: 'recyclerCenterCreate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/RecyclerCenterCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recycler-centers/:recyclerCenterId/edit',
    name: 'recyclerCenterUpdate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/RecyclerCenterUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
